<template>
  <div class="auto-response-capsule">
    <span class="label"><i class="ddi ddi-auto-responder" /></span>
    <span class="message">Auto-response sent</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AutoResponseCapsule',
})
</script>

<style lang="scss">
.auto-response-capsule {
  display: inline-flex;
  align-items: center;
  border-radius: 14px;
  padding: 2px 12px;
  overflow: hidden;
  border: $border--solid-extra-light;
  background-color: var(--color-background-secondary);

  > .label {
    font-size: 13px;
    padding-right: 6px;
    color: var(--color-text-primary);
  }

  > .message {
    @include lettering--p-sm;
    color: var(--color-text-primary);
  }
}
</style>
